// components/data-sources/connectorCatalog/useCanRequestConnectors.ts

import { useAuth } from "@/context/AuthContext";

/**
 * Whether the signed-in user may request a connector: the roles that may add
 * a source (OWNER, ADMIN) and a superadmin, mirroring the backend's
 * `require_account_admin`. Presentation only; the backend route refuses
 * everyone else whatever this says.
 */
export function useCanRequestConnectors(): boolean {
  const { user, activeAccount } = useAuth();
  const role = activeAccount?.role ?? user?.activeAccount?.role;
  return role === "OWNER" || role === "ADMIN" || Boolean(user?.isSuperadmin);
}
